module.exports = __webpack_public_path__ + "img/4DotFusionTest_Icon_200x200_Black.3f676ef5.png";